













































import { Component, Vue, Inject, Prop, Model, Watch } from 'vue-property-decorator'
import appconst from '@/lib/appconst'
@Component
export default class BatchEdit extends Vue {
  @Prop()
  @Model('change', { type: Boolean })
  modal!: boolean

  formValidate = {
    beginTime: '',
    endTime: ''
  }
  cancel() {
    this.$emit('change', false)
  }
  sure() {
    this.$emit('change', this.formValidate)
  }
}
